import { render, staticRenderFns } from "./TableBonus.vue?vue&type=template&id=6febfdf0"
import script from "./TableBonus.vue?vue&type=script&lang=js"
export * from "./TableBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports